<template>
    <LoadingCard v-if="loading"></LoadingCard>
    <div v-else>
        <component :growerId="growerId" :is="component"></component>
    </div>
</template>

<script>
import currentUserQuery from '@views/GrowerOrchardMaps/Container/queryCurrentUser.graphql';
import Browse from './Browse';

export default {
  name: 'GrowerOrchardMapsContainer',
  props: ['growerId'],
  components: {
    Browse,
  },
  apollo: {
    currentUser: {
      query: currentUserQuery,
    },
  },
  watch: {
    currentUser() {
      const validRole = ['contractor', 'processor'].includes(this.currentUser.role.name);

      if (!validRole) {
        this.$notifyFailure('Not allowed.');
        setTimeout(() => this.$router.push({ name: 'dashboard' }), this.$redirectTimeout);
      }
    },
  },
  data() {
    return {
      currentUser: null,
      loading: 0,
    };
  },
  computed: {
    component() {
      if (!this.currentUser) {
        return null;
      }

      return Browse;
    },
  },
};
</script>
